<div id="page-container">
  <div id="content-wrap">
    <div class="account-header">
      <div *ngIf="maxVoters === 5" style="display: flex; justify-content: space-between; height: 100%">
        <span class="banner-text">{{'POLL-DASHBOARD.HEADBAND.MESSAGE-CREATION-SHORT' | translate}}</span>
        <div style="height: 100%; margin-right: 24px; display: flex;">
          <span class="banner-text" style="margin: 0;">{{accountName}}</span>
        </div>
      </div>
      <div *ngIf="maxVoters > 5" style="margin-right: 24px; height: 100%; display: flex; justify-content: flex-end;">
        <span *ngIf="licenseTime == 'D'" class="banner-text">{{accountName}} - {{'POLL-DASHBOARD.HEADBAND.EVENTS' |
          translate}}</span>
        <span *ngIf="licenseTime == 'DM'" class="banner-text">{{accountName}} - {{'POLL-DASHBOARD.HEADBAND.PACK' |
          translate}}</span>
        <span *ngIf="licenseTime == 'Y'" class="banner-text">{{accountName}} - {{'POLL-DASHBOARD.HEADBAND.YEARLY' |
          translate}}</span>
        </div>
    </div>
    <vc-poll-pages-header [title]="poll.title" [isLive]="true" [isPublic]="poll.isUncrypted" [quorum]="poll.quorum" [quorumActual] = "quorumActual"
                          [SMSOption]="poll.isSMS" [is2FA]="poll.is2FA" [isAssessors]="false" (downloadQuorumFile)="downloadQuorumFile()">
    </vc-poll-pages-header>
    <div class="container-live">
      <div class="container-left">
        <vc-poll-ongoing-summary [startDate]="poll.startDate" [endDate]="poll.endDate" (refreshDataEvent)="updateParticipation()"
                                 [votersVoted]="votes" [votersCount]="votersCount" [isLive]="true" [participants]="quorumActual"
                                 [isSms]="poll.isSMS" [isPublic]="poll.isUncrypted" [is2FA]="poll.is2FA" [type]="poll.votingType"
                                 [participation]="percentageString" [sharedLinks]="poll.sharedLinks" [hideTop]="true"  (displayVoters) = "receiveVoterMessage($event)">
        </vc-poll-ongoing-summary>
        <!-- <vc-poll-ongoing-timer [timeDelta]="timeDifference" [isLive]="true"
                                [isPublic]="poll.isUncrypted" (shouldDisplayVoters)="displayVoters()" [sent]="emailsSent" [inviteDate]="inviteDate" [timeDiffHours]="remainingTime"
                                (shouldRelaunchInvitations)="displayRelaunchWarning()" [displayChangeVoters]="true" (shouldChangeVoters)="changeVoter()"
                                [showPreCloseButton]="false">
         </vc-poll-ongoing-timer>  -->
         <div *ngIf="poll.votingType == 'live' || poll.votingType == 'resolution'">
           <vc-live-polls-list [votingType]="poll.votingType" [livePolls]="liveResolutions" [isPublic]="poll.isUncrypted"
             [canAddQuestions]="canAddQuestions" [resolutions]="resolutions" [activeIndex]="activeIndex"
             (submitResolution)="sendNewResolution()" (sendResults)="getResults($event)" [canBeOpened]="canBeOpened" [pollId]="livePollId"
             (sendCommand)="getCommand($event)" (deleteResolutionEvent)="triggerDeletePopup($event)" [hasActiveElection]="hasActiveElection">
           </vc-live-polls-list>
         </div>
         <div *ngIf="poll.votingType == 'liveCandidates' || poll.votingType == 'election'">
           <app-live-candidates-list [votingType]="poll.votingType" [liveChoiceEvents]="liveChoiceEvents" [isPublic]="poll.isUncrypted"
             [isLiveOpen]="isLiveOpen" [choices]="choices" [activeIndex]="activeIndex" [canAddQuestions]="canAddQuestions"
             (submitCandidate)="sendNewCandidate($event)" (sendResults)="getResults($event)"
             (sendCommand)="getCommand($event)" (deleteQuestionEvent)="triggerDeletePopup($event)"
             (sendAnswerImage)="saveCandidateBlob($event)" [hasActiveElection]="hasActiveElection">
           </app-live-candidates-list>
         </div>
       </div>
       <app-confirmation-component [votersCount]="votersCount" [smsVoterCount]="votersCount" [shouldDisplayLive]="true"
         [maxVoters]="maxVoters" [maxSMSVoters]="maxSMSVoters" [canBeClosed]="canBeClosed" (showDraft)="showDraft()"
         (sendCloseCommand)="closePoll()" [poll]="poll" [isFromLive]="true" [attendance]="attendance"
         [eventCounter]="eventCounter" [licenceTime]="licenseTime" [isAssoc]="clientType == 'assoc' || clientType == null"
         [licenceEnd]="licenceEnd" [quorum]="poll.quorum" (showAttendance)="displayParticipants()"
         (shouldDisplayVoters)="displayVoters()" [sent]="emailsSent" (shouldRelaunchInvitations)="displayRelaunchWarning()" (shouldChangeVoters)="changeVoter()"></app-confirmation-component>
     </div>
   </div>
 </div>
 <div *ngIf="isError">
   <app-error (isClosed)="dismissError()" [errorMessage]="errorMessage">
   </app-error>
 </div>
 <div *ngIf="isClosing">
   <vc-warning-popup [understoodButton]="true" [cancelButton]="true" title="{{'LIVE.POPUP.MESSAGE' | translate}}"
     (endDetailsPopup)="popupEvent($event)">
   </vc-warning-popup>
 </div>

   <vc-warning-popup *ngIf="deleteRoundPopup && poll.votingType == 'live'" [pleaseButton]="true"
     title="{{'LIVE.POPUP.DELETE-RESO' | translate}}" (endDetailsPopup)="confirmDeletion($event)">
   </vc-warning-popup>

 <div *ngIf="shouldDisplayVoters">
   <vc-warning-popup title="{{'LIVE.PARTICIPANTS' | translate}}" [mails]="participants" [understoodEndButton]="true"
                     (endDetailsPopup)="dismissParticipants()" [separator]="false">
   </vc-warning-popup>
 </div>
 <div *ngIf="shouldDisplayRemainingVoters">
   <vc-warning-popup title="{{'REMAINING-VOTERS' | translate}}" [mails]="remainingVoters" [understoodEndButton]="true"
                     (endDetailsPopup)="dismissVoters()" [separator]="false" [downloadButton]="true" (sendDownloadOrder)="downloadVoterFile()">
   </vc-warning-popup>
 </div>

   <vc-warning-popup *ngIf="deleteRoundPopup && poll.votingType == 'election'" [pleaseButton]="true"
     title="{{'LIVE.POPUP.DELETE-ELEC' | translate}}" (endDetailsPopup)="confirmDeletion($event)">
   </vc-warning-popup>
 <div *ngIf="shouldChangeVoter">
   <app-change-voter (closeChangeVoter)="closeChangeVoter($event)" [pollId]="livePollId">
   </app-change-voter>
 </div>
 <div *ngIf="shouldDisplayChangeVoterValidation">
   <app-valid-changes (close)="closeChangeValidation()"></app-valid-changes>
 </div>
 <div *ngIf="shouldDisplayRelaunchWarning">
   <app-voters-relaunch (isClosed)="handleRelaunch($event)" [isResend]=true>
   </app-voters-relaunch>
 </div>
 <div *ngIf="loader">
   <vc-loader messageToTheUser="{{'LOADER.DELETE-OPTION' | translate}}">
   </vc-loader>
 </div>
<div *ngIf="displayVoterStatus != ''">
  <vc-warning-popup title="{{votersTitle}}" [mails]="displayedVoters" [understoodEndButton]="true"
                    (endDetailsPopup)="dismissVoters()" [separator]="false">
  </vc-warning-popup>
</div>
